export default  {
	// Menu
	'Summary': {
		en: 'Summary'
	},
	'Statistics': {
		en: 'Statistics'
	},
	'Finances': {
		en: 'Finances'
	},
	'Users': {
		en: 'Users'
	},
	'Offers': {
		en: 'Offers',
		ru: 'Офферы',
		de: 'Angebote',
		vi: 'Các offer',
		th: 'ข้อเสนอต่างๆ'
	},
	'Profile': {
		en: 'Profile'
	},
	'Exit': {
		en: 'Exit'
	},
	'Debt for payment': {
		en: 'Debt for payment'
	},
	'Admins': {
		en: 'Admins'
	},
	'Showcase': {
		en: 'Showcase'
	},
	'Support': {
		en: 'Support'
	},
	// Module admins
	'List of admins' : {
		en: 'List of admins'
	},
	'Create new admin' : {
		en: 'Create new admin'
	},
	'Show more': {
		en: 'Show more'
	},
	'Show %s more': {
		en: 'Show %s more'
	},
	'Id': {
		en: 'Id'
	},
	'Email': {
		en: 'Email'
	},
	'Created': {
		en: 'Created'
	},
	'Updated': {
		en: 'Updated'
	},
	'Is manager': {
		en: 'Is manager'
	},
	'Actions': {
		en: 'Actions'
	},
	'Remove admin': {
		en: 'Remove admin'
	},
	'Return to list of admins': {
		en: 'Return to list of admins'
	},
	'yes': {
		en: 'yes'
	},
	'no': {
		en: 'no'
	},
	'Edit admin': {
		en: 'Edit admin'
	},
	'Upload avatar': {
		en: 'Upload avatar'
	},
	'Name': {
		en: 'Name'
	},
	'Password': {
		en: 'Password'
	},
	'Languages': {
		en: 'Languages'
	},
	'Permissions': {
		en: 'Permissions'
	},
	'Save': {
		en: 'Save'
	},
	'Edit': {
		en: 'Edit'
	},
	'Substituting managers': {
		en: 'Substituting managers'
	},
	// Campaign domains
	'Parking domains': {
		en: 'Parking domains'
	},
	'List of parking domains': {
		en: 'List of parking domains'
	},
	'News Provider': {
		en: 'News Provider'
	},
	'Choose your news portal': {
		en: 'Choose your news portal'
	},
	'Create new parking domain': {
		en: 'Create new parking domain'
	},
	'Domain': {
		en: 'Domain'
	},
	'Advertising system': {
		en: 'Advertising system'
	},
	'Affiliate': {
		en: 'Affiliate'
	},
	'Remove campaign domain': {
		en: 'Remove campaign domain'
	},
	'Return to list of parking domains': {
		en: 'Return to list of parking domains'
	},
	'Edit parking domain': {
		en: 'Edit parking domain'
	},
	// Module statistics
	'Apply': {
		en: 'Apply'
	},
	'General statistics': {
		en: 'General statistics'
	},
	'Conversions': {
		en: 'Conversions'
	},
	'Add filters': {
		en: 'Add filters'
	},
	'Date': {
		en: 'Date'
	},
	'Traffic': {
		en: 'Traffic'
	},
	'Coefficients': {
		en: 'Coefficients'
	},
	'Revenue': {
		en: 'Revenue'
	},
	'Hosts': {
		en: 'Hosts'
	},
	'Hits': {
		en: 'Hits'
	},
	'Total': {
		en: 'Total'
	},
	'Today': {
		en: 'Today'
	},
	'Today and yesterday': {
		en: 'Today and yesterday'
	},
	'Yesterday': {
		en: 'Yesterday'
	},
	'This week': {
		en: 'This week'
	},
	'Last week': {
		en: 'Last week'
	},
	'Current month': {
		en: 'Current month'
	},
	'Last month': {
		en: 'Last month'
	},
	'This year': {
		en: 'This year'
	},
	'Close': {
		en: 'Close'
	},
	// Filters
	'Block': {
		en: 'Block'
	},
	'Delete': {
		en: 'Delete'
	},
	'Exclude': {
		en: 'Exclude'
	},
	'Clear': {
		en: 'Clear'
	},
	'Add offers': {
		en: 'Add offers'
	},
	'Add landings': {
		en: 'Add landings'
	},
	'Add transits': {
		en: 'Add transits'
	},
	'Add countries': {
		en: 'Add countries'
	},
	'Add cities': {
		en: 'Add cities'
	},
	'Add campaigns': {
		en: 'Add campaigns'
	},
	'Add campaign types': {
		en: 'Add campaign types'
	},
	'Add ID': {
		en: 'Add ID'
	},
	'Add sids1': {
		en: 'Add sids1'
	},
	'Add sids2': {
		en: 'Add sids2'
	},
	'Add sids3': {
		en: 'Add sids3'
	},
	'Add sids4': {
		en: 'Add sids4'
	},
	'Add sids5': {
		en: 'Add sids5'
	},

	'Landings': {
		en: 'Landings'
	},
	'Transits': {
		en: 'Transits'
	},
	'Countries': {
		en: 'Countries'
	},
	'Cities': {
		en: 'Cities'
	},
	'Campaigns': {
		en: 'Campaigns'
	},
	'Campaign types': {
		en: 'Campaign types'
	},
	'Traffic types': {
		en: 'Traffic types'
	},
	'ID': {
		en: 'ID'
	},
	'sids1': {
		en: 'sids1'
	},
	'sids2': {
		en: 'sids2'
	},
	'sids3': {
		en: 'sids3'
	},
	'sids4': {
		en: 'sids4'
	},
	'sids5': {
		en: 'sids5'
	},
	// Offers
	'List of offers': {
		en: 'List of offers'
	},
	'Add offer': {
		en: 'Add offer'
	},
	'Offer': {
		en: 'Offer'
	},
	'Geo': {
		en: 'Geo'
	},
	'Links': {
		en: 'Links'
	},
	'Offer editor': {
		en: 'Offer editor'
	},
	'Main': {
		en: 'Main'
	},
	'Marketing report': {
		en: 'Marketing report'
	},
	'Affiliates report': {
		en: 'Affiliates report'
	},
	'Report': {
		en: 'Report'
	},
	'Targeting': {
		en: 'Targeting'
	},
	'Promo': {
		en: 'Promo'
	},
	'Title': {
		en: 'Title'
	},
	'Category': {
		en: 'Category'
	},
	'Status': {
		en: 'Status'
	},
	'Short description': {
		en: 'Short description'
	},
	'Description': {
		en: 'Description'
	},
	'Rules': {
		en: 'Rules'
	},
	'Cancel': {
		en: 'Cancel'
	},
	'Upload': {
		en: 'Upload'
	},
	'Display priority': {
		en: 'Display priority'
	},
	'Attributes of the offer': {
		en: 'Attributes of the offer'
	},
	'Is exclusive': {
		en: 'Is exclusive'
	},
	'Access on request': {
		en: 'Access on request'
	},
	'Add landing': {
		en: 'Add landing'
	},
	'Add transit page': {
		en: 'Add transit page'
	},
	'Priority': {
		en: 'Priority'
	},
	'Delete domain': {
		en: 'Delete domain'
	},
	'Delete targeting': {
		en: 'Delete targeting'
	},
	'Add targeting': {
		en: 'Add targeting'
	},
	'On site': {
		en: 'Site price'
	},
	'Payout %s': {
		en: 'Payout %s'
	},
	'Boost %s': {
		en: 'Boost %s'
	},
	'Callcenter': {
		en: 'Callcenter'
	},
	'Contest': {
		en: 'Contest'
	},
	'Points': {
		en: 'Points'
	},
	'Select location': {
		en: 'Select location'
	},
	'Attach promo': {
		en: 'Attach promo'
	},
	'The total size of uploaded files should not exceed 5 Mb': {
		en: 'The total size of uploaded files should not exceed 5 Mb'
	},
	'Return to list of offers': {
		en: 'Return to list of offers'
	},
	'News': {
		en: 'News',
		ru: 'Новости',
		de: 'Nachrichten',
		vi: 'Tin tức',
		th: 'ข่าวสาร'
	},
	// Support
	'You have access to the offer': {
		en: 'You have access to the offer',
		ru: 'Вам открыт доступ к офферу',
		uk: 'Вам відкрито доступ до ',
		de: 'Du hast Zugriff auf die offer',
		vi: 'Bạn có quyền truy cập vào chương trình',
		th: 'คุณสามารถเข้าถึงข้อเสนอได้แล้ว'
	},
	'You have no access to the offer': {
		en: 'Access request declined',
		ru: 'В доступе к офферу отказано',
		de: 'Der Zugang zur Ausstellung wird verweigert',
		vi: 'Truy cập vào triển lãm bị từ chối',
		th: 'การเข้าถึงข้อเสนอถูกปฏิเสธ'
	},

	'Sale model': {
		en: 'Sale model'
	},
	'The issue is resolved': {
		en: 'The issue is resolved.',
		ru: 'Вопрос решен.',
		de: 'Das Problem wurde behoben.',
		vi: 'Vấn đề đã được giải quyết.',
		th: 'แก้ปัญหาแล้ว'
	},
	'Close panel': {
		ru: 'Свернуть панель',
		en: 'Close panel'
	},
	'List of external requests': {
		en: 'List of external requests'
	},
	'Cabinet': {
		en: 'Cabinet',
		ru: 'Кабинет',
		de: 'Kabinett',
		vi: 'Buồng',
		th: 'คณะรัฐมนตรี'
	},
	'Blog': {
		en: 'Blog',
		ru: 'Блог',
		de: 'Blog',
		vi: 'Blog',
		th: 'บล็อก'
	},
	'You can change your notification preferences in %s Your %s or %s from them': {
		en: 'You can change your notification preferences in %s Your %s or %s from them',
		ru: 'Изменить настройки получения рассылок вы можете в %s Вашем %s или %s от их получения',
		de: 'Sie können Ihre Benachrichtigungseinstellungen in %s Ihrer %s oder %s davon ändern',
		vi: 'Bạn có thể thay đổi cài đặt thông báo của mình %s trong  %s hoặc %s của bạn',
		th: 'คุณสามารถเปลี่ยนการตั้งค่าการแจ้งเตือนใน %s %s หรื อ%s ของคุณได้'
	},
	'personal cabinet': {
		en: 'personal cabinet',
		ru: 'личном кабинете',
		de: 'persönliches Kabinett',
		vi: 'tủ cá nhân',
		th: 'คลิกที่ลิงก์เพื่อแก้ไขประวัติส่วนตัว'
	},
	'unsubscribe': {
		en: 'unsubscribe',
		ru: 'отписаться',
		de: 'abmelden',
		vi: 'hủy đăng ký',
		th: 'ยกเลิกการเป็นสมาชิก'
	},
	'Advantages of RocketProfit': {
		en: 'Advantages of RocketProfit',
		ru: 'Преимущества RocketProfit',
		de: 'Vorteile von RocketProfit',
		vi: 'Ưu điểm của RocketProfit',
		th: 'ข้อดีของ RocketProfit'
	},
	'High income - bets without intermediaries': {
		en: 'High income — bets without intermediaries',
		ru: 'Высокий доход — ставки без посредников',
		de: 'Hohes Einkommen — Preise ohne Vermittler',
		vi: 'Thu nhập cao —  không dưới bất kỳ hình thức làm việc và thanh toán trung gian nào',
		th: '้ผลตอบแทนสูง — ลงทุนโดยไม่ต้องผ่านคนกลาง'
	},
	'Exclusive offers and certified production': {
		en: 'Exclusive offers and certified production',
		ru: 'Эксклюзивные офферы и сертифицированная продукция',
		de: 'Exklusive Angebote und zertifizierte Produkte',
		vi: 'Nguồn sản phẩm được cung cấp độc quyền, đi kèm chứng nhận của sản phẩm',
		th: 'ข้อเสนอ (ออฟเฟอร์) สุดพิเศษ และ ผลิตภัณฑ์ได้รับการรับรอง'
	},
	'Our call center speaks the language of the offers geolocation': {
		en: 'Our call center speaks the language of the offers geolocation',
		ru: 'Колл-центр говорит на языке ГЕО оффера ',
		de: 'Ja, wir sprechen deine Sprache. Call Center spricht die GEO-Sprache des Angebotes',
		vi: 'Trụ sở Callcenter làm việc với hệ thống đa ngôn ngữ',
		th: 'คอลเซ็นเตอร์พูดภาษาท้องถิ่นตามข้อเสนอประเทศนั้นๆ'
	},
	'Join us!': {
		en: 'Join us!',
		ru: 'Присоединяйся!',
		de: 'Begleiten Sie uns!',
		vi: 'Tham gia với!',
		th: 'ร่วมงานกับเรา!'
	},
	'We are in social networks': {
		en: 'We are in social networks',
		ru: ' Мы в социальных сетях',
		de: ' Wir in sozialen Netzwerken',
		vi: 'mạng xã hội',
		th: ' เราอยู่ในเครือข่ายสังคม'
	},
	'You recived this message, because you have been registered on the web page RocketProfit.com. You can manage your e-mail dispatch in the settings of your %s and completly refuse of them (also of password recovery mails, statuses of the billings and tickets!) you can do this passing by this link %s': {
		en: 'You recived this message, because you have been registered on the web page RocketProfit.com. You can manage your e-mail dispatch in the settings of your %s and completly refuse of them (also of password recovery mails, statuses of the billings and tickets!) you can do this passing by this link %s',
		ru: 'Вы получили это письмо, потому что зарегистрировались в RocketProfit. Управлять своей рассылкой вы можете в %s, а полностью отказаться (втч восстановление пароля, статус выплат и тикетов!) вы можете перейдя по ссылке %s',
		de: 'Sie erhalten diese Email, weil Sie sich bei RocketProfit.com registriert haben. Um Ihre Mailingliste zu verwalten, nutzen %s Um sich aus unserer Mailingliste (einschließlich Briefen mit der Passwort-Wiederherstellung, Zahlungs-, Ticketstatus) abzumelden, klicken Sie bitte hier %s',
		vi: 'Bạn nhận được thư này, bởi vì bạn đã đăng ký trên trang web RocketProfit.com. Bạn có thể điều khiển việc phân phối thư trong mục %s, cũng như hủy bỏ phân phối hoàn toàn (bao gồm cả thư khôi phục mật khẩu, thư thông báo tình trạng thanh toán và vé!) bằng cách nhấp vào liên kết %s',
		th: 'ท่านได้รับอีเมล์นี้เนื่องจากได้ลงทะเบียนไว้บนเว็บไซต์ RocketProfit.com %s หรือยกเลิกการลงทะเบียน (รวมถึงการแก้ไขรหัสผ่าน, ตรวจสอบการจ่ายเงิน, และข้อความส่วนตัวได้!) กรุณาคลิ๊กที่ลิงก์เพื่อไปยังหน้าเว็บ %s'
	},

	// start of: ranks and points report

	'ranks-and-points': {
		en: 'Ranks & QUIDs',
		ru: 'Ranks & QUIDs',
		de: 'Ranks & QUIDs',
		vi: 'Ranks & QUIDs',
		th: 'Ranks & QUIDs'
	},
	'affiliate': {
		en: 'affiliate',
		ru: 'веб-мастер',
		de: 'affiliate',
		vi: 'affiliate',
		th: 'affiliate'
	},
	'rank-at-end-of-curr-period': {
		en: 'rank at the end of the current period',
		ru: 'ранк на конец текущего периода',
		de: 'rank at the end of the current period',
		vi: 'rank at the end of the current period',
		th: 'rank at the end of the current period'
	},
	'curr-rank': {
		en: 'current rank',
		ru: 'текущий ранк',
		de: 'current rank',
		vi: 'current rank',
		th: 'current rank'
	},
	'prev-rank': {
		en: 'previous rank',
		ru: 'предыдущий ранк',
		de: 'previous rank',
		vi: 'previous rank',
		th: 'previous rank'
	},
	'conversions-in-curr-period': {
		en: 'conversions in the current period',
		ru: 'конверсии в текущем периоде',
		de: 'conversions in the current period',
		vi: 'conversions in the current period',
		th: 'conversions in the current period'
	},
	'total-conversions': {
		en: 'number of total conversions',
		ru: 'количество всех конверсий',
		de: 'number of total conversions',
		vi: 'number of total conversions',
		th: 'number of total conversions'
	},
	'approved-conversions': {
		en: 'number of approved conversions',
		ru: 'количество одобренных конверсий',
		de: 'number of approved conversions',
		vi: 'number of approved conversions',
		th: 'number of approved conversions'
	},
	'redeemed-conversions': {
		en: 'number of redeemed conversions',
		ru: 'количество выкупленных конверсий',
		de: 'number of redeemed conversions',
		vi: 'number of redeemed conversions',
		th: 'number of redeemed conversions'
	},
	'percent-approved-total-conversions': {
		en: 'percent of approved conversions of all conversions',
		ru: 'процент одобренных конверсий от всех конверсий',
		de: 'percent of approved conversions of all conversions',
		vi: 'percent of approved conversions of all conversions',
		th: 'percent of approved conversions of all conversions'
	},
	'percent-redeemed-approved-conversions': {
		en: 'percent of redeemed conversions of approved conversions',
		ru: 'процент выкупленных конверсий от одобренных конверсий',
		de: 'percent of redeemed conversions of approved conversions',
		vi: 'percent of redeemed conversions of approved conversions',
		th: 'percent of redeemed conversions of approved conversions'
	},
	'balance': {
		en: 'balance',
		ru: 'баланс',
		de: 'balance',
		vi: 'balance',
		th: 'balance'
	},
	'balance-at-end-of-curr-period': {
		en: 'balance at the end of the current period',
		ru: 'баланс на конец текущего периода',
		de: 'balance at the end of the current period',
		vi: 'balance at the end of the current period',
		th: 'balance at the end of the current period'
	},
	'balance-at-end-of-prev-period': {
		en: 'balance at the end of the previous period',
		ru: 'баланс на конец предыдущего периода',
		de: 'balance at the end of the previous period',
		vi: 'balance at the end of the previous period',
		th: 'balance at the end of the previous period'
	},
	'percent-balance-difference': {
		en: 'percent balance difference',
		ru: 'разница баланса в процентах',
		de: 'percent balance difference',
		vi: 'percent balance difference',
		th: 'percent balance difference'
	},
	'purchases': {
		en: 'purchases',
		ru: 'покупки',
		de: 'purchases',
		vi: 'purchases',
		th: 'purchases'
	},
	'purchases-in-curr-period': {
		en: 'purchases in the current period',
		ru: 'покупки в текущем периоде',
		de: 'purchases in the current period',
		vi: 'purchases in the current period',
		th: 'purchases in the current period'
	},
	'purchases-in-prev-period': {
		en: 'purchases in the previous period',
		ru: 'покупки в предыдущем периоде',
		de: 'purchases in the previous period',
		vi: 'purchases in the previous period',
		th: 'purchases in the previous period'
	},
	'purchases-count': {
		en: 'purchases count',
		ru: 'количество покупок',
		de: 'purchases count',
		vi: 'purchases count',
		th: 'purchases count'
	},
	'purchases-value': {
		en: 'purchases value',
		ru: 'стоимость покупок',
		de: 'purchases value',
		vi: 'purchases value',
		th: 'purchases value'
	},
	'desired-good-in-curr-period': {
		en: 'goods marked as "I want to save up" in the current period',
		ru: 'товар отмеченный как "хочу накопить" в текущем периоде',
		de: 'goods marked as "I want to save up" in the current period',
		vi: 'goods marked as "I want to save up" in the current period',
		th: 'goods marked as "I want to save up" in the current period'
	},
	'good-title': {
		en: 'good title',
		ru: 'название подарка',
		de: 'good title',
		vi: 'good title',
		th: 'good title'
	},
	'good-price': {
		en: 'good price',
		ru: 'цена подарка',
		de: 'good price',
		vi: 'good price',
		th: 'good price'
	}

	// end of: ranks and points report
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/config/translation.js